import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  changeWtsProfileSelected,
  createWtsProfiles,
  updateWtsProfiles,
  getWtsProfiles,
} = Actions;

const WtsProfilesModal = ({mode, profileToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const profileSelected = useSelector((state) => state.wtsProfiles.profileSelected);

  const onChangeValues = (value) => {
    const changedProfileSelected = {
      ...profileSelected,
      'description': value.toUpperCase(),
    };
    dispatch(changeWtsProfileSelected(changedProfileSelected));
  };

  const showProfileModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (value) {
      if (mode === 'edit') {
        dispatch(changeWtsProfileSelected(profileToEdit));
      } else {
        dispatch(changeWtsProfileSelected({
          'description': '',
          'status': 'ACTIVO',
        }));
      }
    }
  };

  const saveProfile = async(e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsProfiles(areaSelected.id, {'data': profileSelected}));
    } else {
      dispatch(updateWtsProfiles(areaSelected.id, {'data': profileSelected}));
    }
    dispatch(getWtsProfiles(areaSelected.id));
    setShowModal(false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showProfileModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showProfileModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Perfil' : 'Editar Perfil'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showProfileModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Perfil"
                value={profileSelected?.description || ''}
                onChange={(e, {value}) => onChangeValues(value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => saveProfile(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsProfilesModal;
